import { Box, SxProps, Typography } from '@mui/material';

const container: SxProps = {
  display: 'flex',
  gap: 1,
  alignItems: 'center',
  padding: 1,
  backgroundColor: 'white'
};

const textStyle: SxProps = {
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};

type Props = {
  text: string;
  icon?: React.ReactElement;
};

/** @deprecated */
export const AccordionItem: React.FC<Props> = ({ text, icon }) => {
  return (
    <Box sx={container}>
      {icon}
      <Typography variant="body2" sx={textStyle}>
        {text}
      </Typography>
    </Box>
  );
};
